import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseGoToArrow } from 'assets/images/go-to-arrow.svg';

type PolicyStatusProps = {
  $valid: boolean;
};

export const Section = styled.div`
  padding-top: 8px;
`;

export const Text = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};
  white-space: break-spaces;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;

  & > strong {
    font-weight: 600;
  }
`;

export const PolicyStatus = styled.p<PolicyStatusProps>`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;

  color: ${({ $valid }) => ($valid ? ColorPalette.HEX.GreenPantone : ColorPalette.HEX.RedRYB)};
`;

export const DetailsButton = styled.button`
  display: flex;
  align-items: center;

  background: none;
  border: none;

  font-size: 12px;
  font-weight: 600;
  color: ${ColorPalette.HEX.OriolesOrange};
  margin-top: 16px;

  cursor: pointer;
`;

export const GoToArrow = styled(BaseGoToArrow)`
  margin-left: 2px;
`;

export const Price = styled.span`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
  margin-bottom: 4px;
  margin-left: 10px;
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    -moz-border-radius: 7.5px;
    -webkit-border-radius: 7.5px;
    border-radius: 7.5px;
    margin-right: 3px;
    margin-bottom: 3px;
    background-color: ${ColorPalette.HEX.DimGray};
  }
`;
